import {
  Component,
  OnInit,
  Input,
  ViewEncapsulation,
  Output,
  EventEmitter,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from "@angular/forms";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { EventCreateService } from "../../services/event-create/event-create.service";
import { EventDetailService } from "../../services/event-detail/event-detail.service";
import { EventService } from "../../services/event/event.service";
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import { SbToastService } from "../../services/iziToast/izitoast.service";
import { TimezoneCal } from "../../services/timezone/timezone.service";
// import { TranslateService } from '@ngx-translate/core';
import { UserConfigService } from "../../services/userConfig/user-config.service";
import { ImageSearchService } from "../../services/image-search/image-search.service";
import * as _ from "lodash-es";
import { analyzeAndValidateNgModules } from "@angular/compiler";
import { LibEventService } from "../../services/lib-event/lib-event.service";
import {
  map,
  startWith,
  finalize,
  debounceTime,
  switchMap,
  catchError,
} from "rxjs/operators";
import { userData } from "../../../assets/usersLive";
// const userData = require("../../../../../../../src/assets/api/useList.json");
import { of, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import * as $ from "jquery";
import { ViewChild, ElementRef } from "@angular/core";
import { MatAutocomplete } from "@angular/material/autocomplete";

import {
  of as observableOf,
  throwError as observableThrowError,
  Observable,
  forkJoin,
} from "rxjs";

@Component({
  selector: "sb-event-create",
  templateUrl: "./event-create.component.html",
  styleUrls: ["./event-create.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class EventCreateComponent implements OnInit {
  @Input() formFieldProperties: any;

  @ViewChild("auto") matAutocomplete: MatAutocomplete;
  @ViewChild("userInput") userInput: ElementRef<HTMLInputElement>;

  // @Input() userId: any;
  userId: any;
  username: any;
  eventConfig: any;
  initialFormFieldProperties: any;
  selectedCertificate: any = null;
  // users: any[] = eventFormConfig.result.response.content;
  // users: any[] = userData.result.response.content; // users: any[];
  // users: any[];
  email: string;
  consent: boolean = false;
  selectedUser: any;
  participantList = [];
  public selectedParticipants: string[] = [];
  private userSearchTime: any;
  private unsubscribe = new Subject<void>();
  isPopupOpen = false;

  dropdownSettings = {};
  // console.log(user);

  @Output() closeSaveForm = new EventEmitter();
  @Output() navAfterSave = new EventEmitter();

  today = new Date();
  todayDate = `${this.today.getFullYear()}-${(
    "0" +
    (this.today.getMonth() + 1)
  ).slice(-2)}-${("0" + this.today.getDate()).slice(-2)}`;
  // todayDate = new Date().toISOString().slice(0, 10);

  formValues: any;

  startTime: any =
    ("0" + (this.today.getHours() + 1)).slice(-2) +
    ":" +
    ("0" + this.today.getMinutes()).slice(-2);
  endTime: any =
    ("0" + (this.today.getHours() + 2)).slice(-2) +
    ":" +
    ("0" + this.today.getMinutes()).slice(-2);
  registrationStartDate: any = this.todayDate;
  registrationEndDate: any;
  timeDiff: any;
  queryParams: any;
  eventDetailsForm: any;
  isSubmitted = false;
  formFieldData: any;
  FormData: any;
  isNew: boolean = true;
  timezoneshort: any;
  canPublish: boolean = false;
  offset = this.timezoneCal.getTimeOffset();
  constFormFieldProperties: any;
  flag: boolean = true;
  tempEventType = null;
  tempVisibility = null;
  tempRecuring: boolean = false;
  tempTypeRecuring = null;
  tempRepeatEveryRecurring = null;
  tempEndRecurring: boolean = false;
  tempEndRecVeriable: String;
  isDisabled: boolean = false;
  defaultTypeOfRecurring: String;
  weekday = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  prefixes = ["First", "Second", "Third", "Fourth", "Fifth"];
  tempEndRecurringVar: String;
  eventValue: any;
  ImageConfig: any;
  gMeeteventID: String;
  eventID: String;
  eventLink: String;
  versionKey: String;
  public showAppIcon = true;
  public appIconConfig = {
    code: "appIcon",
    dataType: "text",
    description: "appIcon of the content",
    editable: true,
    inputType: "appIcon",
    label: "Icon",
    name: "Icon",
    placeholder: "Icon",
    renderingHints: { class: "sb-g-col-lg-1 required" },
    required: true,
    visible: true,
  };
  public appIcon: any;
  editmode: any;
  public showImagePicker = true;
  tempOnlineProvider: any;
  @Input()
  selectedUserIds: string[] = []; // Array to store selected user IDs
  editDataEvent: any;
  eventImage: any;
  searchControl = new FormControl();
  filteredUsers: any[];
  certificateList: any[] = [];
  selectedUsers: any[] = [];
  userMap: { [id: string]: any } = {};

  constructor(
    private activatedRoute: ActivatedRoute,
    private eventCreateService: EventCreateService,
    private eventDetailService: EventDetailService,
    private eventService: EventService,
    private router: Router,
    private location: Location,
    private sbToastService: SbToastService,
    private formBuilder: FormBuilder,
    private timezoneCal: TimezoneCal,
    // private translate: TranslateService,
    private userConfigService: UserConfigService,
    private imageSearchService: ImageSearchService,
    public libEventService: LibEventService
  ) {
    this.selectedUser = [];
  }

  // Ankita changes
  setAppIconData() {
    const isRootNode = true;
    this.appIcon = this.queryParams?.appIcon;
    // this.appIcon = "";
    if (this.isReviewMode()) {
      this.appIconConfig = {
        ...this.appIconConfig,
        ...{ isAppIconEditable: false },
      };
    } else {
      this.appIconConfig = {
        ...this.appIconConfig,
        ...{ isAppIconEditable: true },
      };
    }
  }

  isReviewMode() {
    // this.imageSearchService.getEditMode().subscribe((data: any) => {
    this.editmode = "edit";
    // });

    return _.includes(["review", "read", "sourcingreview"], this.editmode);
  }

  ngOnInit() {
    const prefilledUserIds = []; // setValue to handle edit case
    if (!_.isEmpty(prefilledUserIds)) {
      this.selectedUserIds = prefilledUserIds;
      this.fetchAndMapExistingUsers(prefilledUserIds);
    }
    this.searchControl.valueChanges
      .pipe(
        startWith(""), // Emit an empty string initially to trigger the first API call
        debounceTime(300),
        switchMap((query) => this.getUsers(query)) // Call the API based on the input
      )
      .subscribe((users) => {
        this.filteredUsers = users.filter(
          (user) => !this.isUserSelected(user.userId)
        ); // Filter out selected users
      });
    this.getCertificateList();

    this.eventConfig = _.get(this.libEventService.eventConfig, "context");
    this.userId = this.eventConfig.uid;
    this.username = this.eventConfig.firstName;
    this.ImageConfig = _.get(this.libEventService.eventConfig, "context");
    this.timezoneshort = this.timezoneCal.timeZoneAbbreviated();
    this.activatedRoute.queryParams.subscribe((params) => {
      this.queryParams = params;
      if (this.queryParams?.identifier) {
        this.isNew = false;
      }
    });

    if (this.queryParams?.identifier) {
      this.eventCreateService.getEventFormConfig().subscribe((data: any) => {
        //this.formFieldProperties = data.result['form'].data.fields;
        this.formFieldProperties = data.result["form"].data.properties;
      });

      this.eventDetailService.getEvent(this.queryParams?.identifier).subscribe(
        (data: any) => {
          if (data.result.event.status == "Live") {
            this.isDisabled = true;
          }
          this.versionKey = data.result.event.versionKey;
          this.editDataEvent = data.result.event;
          this.eventImage = data.result.event.appIcon;

          setTimeout(() => this.initializeFormFields(), 500);
          this.setAppIconData();
        },
        (err: any) => {}
      );
    }

    if (!this.queryParams.identifier) {
      this.prepareFormConfiguration();
    }
    let group = {};
  }

  fetchAndMapExistingUsers(userIds: string[]) {
    const payload = { request: { query: "", filters: { userId: userIds } } };
    this.eventCreateService.getUserData(payload).subscribe((response) => {
      const users = response.result.response.content;
      if (users) {
        this.updateUserMap(users);
        this.selectedUsers = [...users];
      }
    });
  }

  getCertificateList() {
    this.eventService.getCertificateList().subscribe((response) => {
      const users = response.result.content;
      this.certificateList = users;
    });
  }

  getUsers(query: string): Observable<any[]> {
    // Set limit based on whether the query is empty or not
    const limit = query ? 20 : 50;

    return this.eventCreateService
      .getUserData({
        request: { query, filters: {}, limit },
      })
      .pipe(
        map((response) => {
          const users = response.result.response.content;
          // Update user map with fetched users
          this.updateUserMap(users);
          return users;
        }),
        catchError((error) => {
          console.error("API call failed: ", error);
          this.sbToastService.showIziToastMsg(
            "Failed to load users. Please try again later",
            "warning"
          );
          return of([]); // Return an empty array or handle the error as appropriate
        })
      );
  }

  updateUserMap(users: any[]): void {
    users.forEach((user) => (this.userMap[user.userId] = user));
  }

  isUserSelected(userId: string): boolean {
    return this.selectedUserIds.includes(userId);
  }

  onOptionSelected(event: any): void {
    const selectedUserId = event.option.value;

    if (!this.selectedUserIds.includes(selectedUserId)) {
      this.selectedUserIds.push(selectedUserId);
      const selectedUser = this.userMap[selectedUserId];
      if (selectedUser) {
        this.selectedUsers.push(selectedUser);
      }
      // Update filteredUsers list
      this.filteredUsers = this.filteredUsers.filter(
        (user) => user.userId !== selectedUserId
      );
    }

    console.log("selectedUserId on select ==>", this.selectedUserIds);

    this.searchControl.setValue("");
    this.userInput.nativeElement.blur();
  }

  removeUser(user: any): void {
    const index = this.selectedUsers.indexOf(user);
    if (index >= 0) {
      this.selectedUsers.splice(index, 1);
      this.selectedUserIds.splice(this.selectedUserIds.indexOf(user.userId), 1); // Remove user ID from selectedUserIds
      this.filterUsers(this.searchControl.value); // Re-filter the list after removing a user
    }
    console.log("selectedUserId on remove ==>", this.selectedUserIds);
  }

  filterUsers(query: string): void {
    // Refetch users based on the current input query
    this.getUsers(query).subscribe((users) => {
      this.filteredUsers = users.filter(
        (user) => !this.isUserSelected(user.userId)
      );
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  isPrivateEvent(): boolean {
    return this.formValues?.eventVisibility === "Private";
  }

  isAttachCertificate(): boolean {
    return this.formValues?.issueCerificate === "Yes";
  }

  openPopup(canPublish) {
    console.log(this.formValues);
    console.log(this.selectedCertificate, "selectedCertificate------");

    if (this.formValues == undefined) {
      this.sbToastService.showIziToastMsg("Please enter event name", "warning");
    } else if (
      this.formValues.name == undefined ||
      this.formValues.name.trim() == ""
    ) {
      this.sbToastService.showIziToastMsg("Please enter event name", "warning");
    } else if (
      this.formValues.eventOrganisedBy == undefined ||
      this.formValues.eventOrganisedBy == null ||
      this.formValues.eventOrganisedBy == ""
    ) {
      this.sbToastService.showIziToastMsg(
        "Please enter EventOrganisedby",
        "warning"
      );
    } else if (
      this.formValues.description == undefined ||
      this.formValues.description == null
    ) {
      this.sbToastService.showIziToastMsg(
        "Please enter description",
        "warning"
      );
    } else if (
      this.formValues.eventVisibility == undefined ||
      this.formValues.eventVisibility == null
    ) {
      this.sbToastService.showIziToastMsg(
        "Please Select eventVisibility",
        "warning"
      );
    } else if (
      this.formValues.board == undefined ||
      this.formValues.board == null
    ) {
      this.sbToastService.showIziToastMsg("Please Select Domain", "warning");
    } else if (
      this.formValues.gradeLevel == undefined ||
      this.formValues.gradeLevel == null
    ) {
      this.sbToastService.showIziToastMsg(
        "Please Select Sub-Domain",
        "warning"
      );
    } else if (
      this.formValues.startDate == undefined ||
      this.formValues.startDate == "dd:mm:yyyy" ||
      this.formValues.startDate == ""
    ) {
      this.sbToastService.showIziToastMsg(
        "Please enter valid event start date",
        "warning"
      );
    }
    // else if (this.formValues.startDate == this.todayDate) {
    //   this.sbToastService.showIziToastMsg(
    //     "The start date must be at least one day in the future; creating events for today is not permitted.",
    //     "warning"
    //   );
    // }
    else if (this.formValues.startDate < this.todayDate) {
      this.sbToastService.showIziToastMsg(
        "The start date cannot be in the past. Please choose a date that is at least one day after today.",
        "warning"
      );
    } else if (
      this.formValues.registrationStartDate == undefined ||
      this.formValues.registrationStartDate == "dd:mm:yyyy" ||
      this.formValues.startDate == ""
    ) {
      this.sbToastService.showIziToastMsg(
        "Please enter valid event Registration start date",
        "warning"
      );
    } else if (this.formValues.registrationStartDate < this.todayDate) {
      this.sbToastService.showIziToastMsg(
        "The Registartion start date cannot be in the past. Please choose a date that is at least one day after today.",
        "warning"
      );
    } else if (
      this.formValues.registrationStartDate > this.formValues.startDate
    ) {
      this.sbToastService.showIziToastMsg(
        "The Registartion start date cannot be greater than event start date. Please choose a date that is at least one day before event start date.",
        "warning"
      );
    }
    // else if (
    //   this.formValues.registrationStartDate == this.formValues.startDate
    // ) {
    //   this.sbToastService.showIziToastMsg(
    //     "Registration start Date should be at least one day before event start date",
    //     "warning"
    //   );
    // }
    else if (
      this.formValues.startTime == undefined ||
      this.formValues.startTime == "hh:mm:ss"
    ) {
      this.sbToastService.showIziToastMsg(
        "Please enter Event Start time",
        "warning"
      );
    } else if (
      this.formValues.endTime == undefined ||
      this.formValues.endTime == "hh:mm:ss"
    ) {
      this.sbToastService.showIziToastMsg(
        "Please enter Event End time",
        "warning"
      );
    } else if (this.formValues.endTime < this.formValues.startTime) {
      this.sbToastService.showIziToastMsg(
        "end Time should be gretter than start time",
        "warning"
      );
    }
    // else if (this.formValues.registrationEndDate == undefined || this.formValues.registrationEndDate == "") {
    //   this.formValues.registrationEndDate=this.formValues.startDate;
    // }
    else if (
      this.formValues.issueCerificate == undefined ||
      this.formValues.issueCerificate == null
    ) {
      this.sbToastService.showIziToastMsg(
        "Please Select do you want to issue Certificate or Not",
        "warning"
      );
    } else if (
      this.formValues.registrationStartDate == undefined ||
      this.formValues.registrationStartDate == ""
    ) {
      this.sbToastService.showIziToastMsg(
        "Please enter valid event registration start date",
        "warning"
      );
    } else if (
      this.formValues.startDate < this.formValues.registrationStartDate &&
      this.formValues.startDate != this.formValues.registrationStartDate &&
      this.formValues.eventVisibility == "Public"
    ) {
      this.sbToastService.showIziToastMsg(
        "Registration start date should be less than event start date",
        "warning"
      );
    } else if (
      this.formValues?.eventVisibility === "Private" &&
      _.isEmpty(this.selectedUserIds)
    ) {
      this.sbToastService.showIziToastMsg(
        "Please select users for private event",
        "warning"
      );
    } else {
      this.isPopupOpen = true;
    }
  }

  closePopup() {
    this.isPopupOpen = false;
  }

  submitPopup() {
    if (this.email && this.consent) {
      // Call postData(true) after email and consent is provided
      this.postData(true);
      this.closePopup(); // Close modal after submission
    } else {
      alert("Please provide a valid email and consent.");
    }
  }
  /*
   * For set event form config
   */
  prepareFormConfiguration() {
    this.formFieldProperties.forEach((formField) => {
      formField.fields.forEach((formField) => {
        switch (formField.code) {
          case "eventType":
            this.tempEventType = formField.default ? formField.default : null;
          // this.setEventTypeDependentFields(formField.default);
          //   break;
          // case "eventVisibilty":
          //   // this.setEventTypeDependentFields("Private");
          //   break;
          // case "registrationStartDate":
          // case "registrationEndDate":
          // case "startDate":
          // case "endDate":
          //   formField.default = this.todayDate;
          //   break;

          // case "startTime":
          //   formField.default = this.startTime;
          //   break;

          // case "endTime":
          //   formField.default = this.endTime;
          //   break;
        }
      });
    });
    this.onValueChangeUpdateFieldBehaviour();
  }

  /**
   * For setting event Dependent Fields
   */
  setEventTypeDependentFields(value) {
    switch (value) {
      case "Online":
        this.clearEventTypeFieldsOnSwitch();
        this.formFieldProperties[1].fields[1].editable = true;
        this.formFieldProperties[1].fields[2].editable = false;
        this.formFieldProperties[1].fields[3].editable = false;
        break;

      case "Offline":
        this.clearEventTypeFieldsOnSwitch();
        this.formFieldProperties[1].fields[1].editable = true;
        this.formFieldProperties[1].fields[2].editable = false;
        this.formFieldProperties[1].fields[3].editable = false;
        break;

      case "OnlineAndOffline":
        this.clearEventTypeFieldsOnSwitch();
        this.formFieldProperties[1].fields[1].editable = true;
        this.formFieldProperties[1].fields[2].editable = false;
        this.formFieldProperties[1].fields[3].editable = false;
        break;

      // case "Private":
      //   this.formFieldProperties[1].fields[13].inputType = "hidden";
      //   this.formFieldProperties[1].fields[13].editable = false;

      default:
        this.formFieldProperties[1].fields[1].editable = false;
        this.formFieldProperties[1].fields[2].editable = false;
        this.formFieldProperties[1].fields[3].editable = false;
        break;
    }
  }

  clearEventTypeFieldsOnSwitch() {
    this.formFieldProperties[1].fields[1].default = ""; //venue
    this.formFieldProperties[1].fields[2].default = null; //online provider
    this.formFieldProperties[1].fields[3].default = ""; //online provider data(link)
    this.formFieldProperties[1].fields[3].placeholder = "https://meetingLink";
  }

  output(event) {}

  onStatusChanges(event) {}

  initializeFormFields() {
    var editValues = {};
    var eventStart = this.timezoneCal.calcTime(
      this.editDataEvent["startDate"],
      this.editDataEvent["startTime"]
    );
    var eventEnd = this.timezoneCal.calcTime(
      this.editDataEvent["endDate"],
      this.editDataEvent["endTime"]
    );

    this.formFieldProperties.forEach((formField) => {
      formField.fields.forEach((formField) => {
        if (formField.code in this.editDataEvent) {
          if (formField.code == "venue") {
            formField.default = this.editDataEvent[formField.code]["name"];
            editValues[formField.code] =
              this.editDataEvent[formField.code]["name"];
          } else if (formField.code == "onlineProviderData") {
            formField.default =
              this.editDataEvent[formField.code]["meetingLink"];
            editValues[formField.code] =
              this.editDataEvent[formField.code]["meetingLink"];
          } else if (formField.code == "eventType") {
            formField.default = this.editDataEvent[formField.code];
            editValues[formField.code] = this.editDataEvent[formField.code];
            // this.setEventTypeDependentFields(formField.default);
          } else if (formField.code == "startTime") {
            (formField.default =
              ("0" + eventStart.getHours()).slice(-2) +
              ":" +
              ("0" + eventStart.getMinutes()).slice(-2) +
              ":" +
              ("0" + eventStart.getSeconds()).slice(-2)),
              (editValues[formField.code] = this.editDataEvent[formField.code]);
          } else if (formField.code == "endTime") {
            (formField.default =
              ("0" + eventEnd.getHours()).slice(-2) +
              ":" +
              ("0" + eventEnd.getMinutes()).slice(-2) +
              ":" +
              ("0" + eventEnd.getSeconds()).slice(-2)),
              (editValues[formField.code] = this.editDataEvent[formField.code]);
          } else {
            formField.default = this.editDataEvent[formField.code];
            editValues[formField.code] = this.editDataEvent[formField.code];
          }
        }
      });
    });

    this.formValues = editValues;
    this.formFieldData = this.formFieldProperties;
  }

  /**
   * For Changing values on event form
   */
  valueChanges(eventData) {
    console.log(eventData);
    console.log(this.selectedCertificate, "selectedCertificate------");

    if (eventData?.eventVisibility === "Public") {
      this.selectedUsers = [];
      this.selectedUserIds = [];
      this.userMap = {};
      this.filteredUsers = [];
      this.searchControl.setValue("");
    }
    if (eventData) {
      this.formValues = eventData;
      if (this.flag) {
        this.constFormFieldProperties = this.formFieldProperties;
        this.flag = false;
      } else {
        this.formFieldProperties = this.constFormFieldProperties;
        this.formFieldProperties.forEach((formField) => {
          formField.fields.forEach((formField) => {
            //console.log(formField.fields.code,"Code");
            formField.default = eventData[formField.code];
          });
        });
      }
    }

    let eventType;

    if (eventData.eventType != this.tempEventType) {
      this.tempEventType = eventData.eventType;
      // this.setEventTypeDependentFields(eventData.eventType);
      this.onValueChangeUpdateFieldBehaviour();
    }

    if (eventData.onlineProvider != this.tempOnlineProvider) {
      this.tempOnlineProvider = eventData.onlineProvider;
      this.setOnlineProviderDependentFields(eventData.onlineProvider);
      this.onValueChangeUpdateFieldBehaviour();
    }
  }
  setOnlineProviderDependentFields(value) {
    switch (
      value
      // case "Zoom":
      //   this.formFieldProperties[1].fields[3].editable = false;
      //   this.formFieldProperties[1].fields[3].placeholder = "Auto Generated";
      //   break;

      // case "BigBlueButton":
      // case "Zoom":
      // case "Jitsi":
      //   this.formFieldProperties[1].fields[3].editable = true;
      //   this.formFieldProperties[1].fields[3].placeholder =
      //     "https://meetingLink";
      //   break;
      // default:
      //   this.formFieldProperties[1].fields[3].editable = true;
      //   this.formFieldProperties[1].fields[3].placeholder =
      //     "https://meetingLink";
      //   break;
    ) {
    }
  }

  /**
   * For values change on form after change in checkbox, dropdown fields
   */
  onValueChangeUpdateFieldBehaviour() {
    this.formFieldProperties = JSON.parse(
      JSON.stringify(this.formFieldProperties)
    );
    if (this.formFieldData) {
      this.formFieldData = JSON.parse(JSON.stringify(this.formFieldData));
    }
  }

  /**
   * For validate data and call post form service
   */
  postData(canPublish) {
    this.isSubmitted = true;
    this.canPublish = canPublish;
    console.log("consent-----", this.consent);

    console.log("Form Values:", this.formValues);

    // Add logging to check formValues at this stage

    if (this.formValues == undefined) {
      this.sbToastService.showIziToastMsg("Please enter event name", "warning");
    } else if (
      this.formValues.name == undefined ||
      this.formValues.name.trim() == ""
    ) {
      this.sbToastService.showIziToastMsg("Please enter event name", "warning");
    } else if (
      this.formValues.eventOrganisedBy == undefined ||
      this.formValues.eventOrganisedBy == null ||
      this.formValues.eventOrganisedBy == ""
    ) {
      this.sbToastService.showIziToastMsg(
        "Please enter EventOrganisedby",
        "warning"
      );
    } else if (
      this.formValues.description == undefined ||
      this.formValues.description == null
    ) {
      this.sbToastService.showIziToastMsg(
        "Please enter description",
        "warning"
      );
    } else if (
      this.formValues.eventVisibility == undefined ||
      this.formValues.eventVisibility == null
    ) {
      this.sbToastService.showIziToastMsg(
        "Please Select eventVisibility",
        "warning"
      );
    } else if (
      this.formValues.board == undefined ||
      this.formValues.board == null
    ) {
      this.sbToastService.showIziToastMsg("Please Select Domain", "warning");
    } else if (
      this.formValues.gradeLevel == undefined ||
      this.formValues.gradeLevel == null
    ) {
      this.sbToastService.showIziToastMsg(
        "Please Select Sub-Domain",
        "warning"
      );
    } else if (
      this.formValues.startDate == undefined ||
      this.formValues.startDate == "dd:mm:yyyy" ||
      this.formValues.startDate == ""
    ) {
      this.sbToastService.showIziToastMsg(
        "Please enter valid event start date",
        "warning"
      );
    }
    // else if (this.formValues.startDate == this.todayDate) {
    //   this.sbToastService.showIziToastMsg(
    //     "The start date must be at least one day in the future; creating events for today is not permitted.",
    //     "warning"
    //   );
    // }
    else if (this.formValues.startDate < this.todayDate) {
      this.sbToastService.showIziToastMsg(
        "The start date cannot be in the past. Please choose a date that is at least one day after today.",
        "warning"
      );
    } else if (
      this.formValues.registrationStartDate == undefined ||
      this.formValues.registrationStartDate == "dd:mm:yyyy" ||
      this.formValues.startDate == ""
    ) {
      this.sbToastService.showIziToastMsg(
        "Please enter valid event Registration start date",
        "warning"
      );
    } else if (this.formValues.registrationStartDate < this.todayDate) {
      this.sbToastService.showIziToastMsg(
        "The Registartion start date cannot be in the past. Please choose a date that is at least one day after today.",
        "warning"
      );
    } else if (
      this.formValues.registrationStartDate > this.formValues.startDate
    ) {
      this.sbToastService.showIziToastMsg(
        "The Registartion start date cannot be greater than event start date. Please choose a date that is at least one day before event start date.",
        "warning"
      );
    }
    // else if (
    //   this.formValues.registrationStartDate == this.formValues.startDate
    // ) {
    //   this.sbToastService.showIziToastMsg(
    //     "Registration start Date should be at least one day before event start date",
    //     "warning"
    //   );
    // }
    else if (
      this.formValues.startTime == undefined ||
      this.formValues.startTime == "hh:mm:ss"
    ) {
      this.sbToastService.showIziToastMsg(
        "Please enter Event Start time",
        "warning"
      );
    } else if (
      this.formValues.endTime == undefined ||
      this.formValues.endTime == "hh:mm:ss"
    ) {
      this.sbToastService.showIziToastMsg(
        "Please enter Event End time",
        "warning"
      );
    } else if (this.formValues.endTime < this.formValues.startTime) {
      this.sbToastService.showIziToastMsg(
        "end Time should be gretter than start time",
        "warning"
      );
    }
    // else if (this.formValues.registrationEndDate == undefined || this.formValues.registrationEndDate == "") {
    //   this.formValues.registrationEndDate=this.formValues.startDate;
    // }
    else if (
      this.formValues.issueCerificate == undefined ||
      this.formValues.issueCerificate == null
    ) {
      this.sbToastService.showIziToastMsg(
        "Please Select do you want to issue Certificate or Not",
        "warning"
      );
    } else if (
      (canPublish == true &&
        !this.queryParams?.identifier &&
        this.email == undefined) ||
      (this.email == undefined) == null
    ) {
      this.sbToastService.showIziToastMsg(
        "Please provide your EmailId",
        "warning"
      );
    } else if (
      (canPublish == true &&
        !this.queryParams?.identifier &&
        this.consent == false) ||
      (this.email == undefined) == null
    ) {
      this.sbToastService.showIziToastMsg(
        "Please accept the consent",
        "warning"
      );
    } else if (
      this.formValues.registrationStartDate == undefined ||
      this.formValues.registrationStartDate == ""
    ) {
      this.sbToastService.showIziToastMsg(
        "Please enter valid event registration start date",
        "warning"
      );
    } else if (
      this.formValues.startDate < this.formValues.registrationStartDate &&
      this.formValues.startDate != this.formValues.registrationStartDate &&
      this.formValues.eventVisibility == "Public"
    ) {
      this.sbToastService.showIziToastMsg(
        "Registration start date should be less than event start date",
        "warning"
      );
    } else if (
      this.formValues?.eventVisibility === "Private" &&
      _.isEmpty(this.selectedUserIds)
    ) {
      this.sbToastService.showIziToastMsg(
        "Please select users for private event",
        "warning"
      );
    }
    // else if (
    //   this.formValues.startDate < this.formValues.registrationStartDate ||
    //   this.formValues.startDate == this.formValues.registrationStartDate
    // ) {
    //   this.sbToastService.showIziToastMsg(
    //     "Registration start date should be less than event start date",
    //     "warning"
    //   );
    // }
    else {
      this.formValues = Object.assign(this.formValues);

      // Additional logging before API call
      console.log("Final Form Values:", this.formValues);
      console.log("Final Selected UserIds:", this.selectedUserIds);

      if (this.queryParams?.identifier) {
        this.formValues["identifier"] = this.queryParams.identifier;
      }

      this.formValues["onlineProviderData"] =
        this.formValues["onlineProviderData"] != null
          ? { meetingLink: this.formValues["onlineProviderData"] }
          : {};
      this.formValues["venue"] = { name: this.formValues["venue"] };
      this.formValues["owner"] = this.userId;
      // this.formValues["createdFor"] = this.eventConfig.organisationIds;
      this.formValues["appIcon"] = this.appIcon;
      console.log("consent----", this.consent);

      if (this.isNew) {
        if (this.queryParams?.endTime != this.formValues.endTime) {
          this.formValues["endTime"] =
            this.formValues["endTime"] + ":10" + this.offset;
        }
        this.formValues.eventType = "Online";
        this.formValues.endDate = this.formValues.startDate;
        this.formValues.registrationEndDate = this.formValues.startDate;
        this.formValues.code = "111";

        if (this.queryParams?.startTime != this.formValues.startTime) {
          this.formValues["startTime"] =
            this.formValues["startTime"] + ":10" + this.offset;
        }
        this.eventCreateService.createEvent(this.formValues).subscribe(
          (data) => {
            console.log("consent-----", this.consent);

            if (data.responseCode === "OK") {
              this.eventID = data.result.identifier;
              this.versionKey = data.result.versionKey;

              this.eventCreateService
                .createGmeetEvent(this.formValues, this.eventID, this.userId)
                .subscribe(
                  (gmeetData) => {
                    this.gMeeteventID = gmeetData.result.id;
                    this.eventLink = gmeetData.result.hangoutLink;

                    // On success, call getGmeetLink
                    this.eventCreateService
                      .getGmeetLink(this.gMeeteventID)
                      .subscribe(
                        (linkData) => {
                          this.eventCreateService
                            .updateEventwithGmeetLink(
                              this.eventLink,
                              this.eventID,
                              this.versionKey
                            )
                            .subscribe(
                              (updateData) => {
                                if (updateData.responseCode === "OK") {
                                  this.dataSubmitted(data, "create");
                                }
                                console.log(
                                  "Event updated with Gmeet link: ",
                                  updateData
                                );
                              },
                              (err: any) => {
                                console.log(
                                  "Error updating event with Gmeet link: ",
                                  err
                                );
                                this.sbToastService.showIziToastMsg(
                                  err.message,
                                  "error"
                                );
                              }
                            );
                        },
                        (err: any) => {
                          this.sbToastService.showIziToastMsg(
                            err.message,
                            "error"
                          );
                        }
                      );
                  },
                  (err: any) => {
                    // On error, log error and still call getGmeetLink
                    this.sbToastService.showIziToastMsg(err.message, "error");

                    // Call getGmeetLink even if createGmeetEvent fails
                    this.eventCreateService
                      .getGmeetLink(this.gMeeteventID)
                      .subscribe(
                        (linkData) => {
                          this.eventCreateService
                            .updateEventwithGmeetLink(
                              linkData.result.data.hangoutLink,
                              this.eventID,
                              this.versionKey
                            )
                            .subscribe(
                              (updateData) => {
                                if (updateData.responseCode === "OK") {
                                  this.dataSubmitted(data, "create");
                                }
                              },
                              (err: any) => {
                                this.sbToastService.showIziToastMsg(
                                  err.message,
                                  "error"
                                );
                              }
                            );
                        },
                        (err: any) => {
                          this.sbToastService.showIziToastMsg(
                            err.message,
                            "error"
                          );
                        }
                      );
                  }
                );
            }
          },
          (err: any) => {
            this.sbToastService.showIziToastMsg(err.message, "error");
          }
        );
      } else {
        this.formValues.eventType = "Online";
        this.formValues.endDate = this.formValues.startDate;
        this.formValues.registrationEndDate = this.formValues.startDate;
        this.formValues.code = "111";
        if (this.queryParams?.endTime != this.formValues.endTime) {
          this.formValues["endTime"] = this.formValues["endTime"] + this.offset;
        }

        if (this.queryParams?.startTime != this.formValues.startTime) {
          this.formValues["startTime"] =
            this.formValues["startTime"] + this.offset;
        }
        this.formValues["versionKey"] = this.versionKey;
        this.eventCreateService.updateEvent(this.formValues).subscribe(
          (data) => {
            if (data.responseCode == "OK") {
              this.dataSubmitted(data, "update");
            }
          },
          (err) => {
            console.log({ err });
            // this.sbToastService.showIziToastMsg(err.error.result.messages[0], 'error');
          }
        );
      }
    }
  }

  dataSubmitted(data, task) {
    if (this.canPublish) {
      this.eventCreateService
        .publishEvent(data.result.identifier)
        .subscribe((res) => {
          if (task == "create") {
            this.sbToastService.showIziToastMsg(
              "Event Created Successfully",
              "success"
            );
          } else {
            this.sbToastService.showIziToastMsg(
              "Event updated Successfully",
              "success"
            );
          }

          // Only publish event can able to create batch
          this.createEventBatch(data);

          this.navAfterSave.emit(data);
        });
    } else {
      if (task == "create") {
        this.sbToastService.showIziToastMsg(
          "Event Created Successfully",
          "success"
        );
      } else {
        this.sbToastService.showIziToastMsg(
          "Event updated Successfully",
          "success"
        );
      }

      this.navAfterSave.emit(data);
    }
  }

  /**
   * NOTE: Once the event is created, the batch will be created automatically.
   * Right now the batch is not created after event creating, so we are implementing some temporary solution
   *
   * Create event batch
   * Here, confirm that one event have only one batch.
   * @param data array of created event id
   * @param formValue event form value
   */
  createEventBatch(data) {
    // Check whether Event has batch or not
    // filter set for serch batch for selected event
    let filters = {
      courseId: data.result.identifier,
      // enrollmentType: "open",
    };

    this.eventDetailService
      .getEvent(data.result.identifier)
      .subscribe((response: any) => {
        this.eventValue = response.result.event;

        // Determine the enrollment type and user list based on event visibility
        let enrollmentType =
          this.eventValue.eventVisibility === "Private"
            ? "invite-only"
            : "open";

        const start = new Date(this.eventValue.startDate);
        const end = new Date(start);
        end.setDate(start.getDate() + 1);
        const endDate = end.toISOString().split("T")[0];
        console.log("endDate----", endDate);

        // request value for create batch for selected event
        let createBatchRequestValue = {
          courseId: data.result.identifier,
          name: "Batch for event - " + data.result.identifier,
          description: "Batch for event - " + data.result.identifier,
          enrollmentType: enrollmentType,
          startDate: this.eventValue.registrationStartDate,
          endDate: endDate,
          createdBy: this.eventValue.owner,
        };

        this.eventService.getBatches(filters).subscribe(
          (res) => {
            if (res.responseCode == "OK") {
              if (res.result.response.count == 0) {
                // If batch not created then create the batch for event
                this.eventService
                  .createBatch(createBatchRequestValue)
                  .subscribe(
                    (createRes) => {
                      console.log(createRes, "createRes");
                      if (createRes.result.response === "SUCCESS") {
                        if (this.formValues.issueCerificate === "Yes") {
                          this.eventService
                            .attchCertificate(
                              createBatchRequestValue,
                              createRes.result.batchId,
                              this.selectedCertificate
                            )
                            .subscribe((result) => {
                              console.log(
                                result,
                                "Certificate Attached Successfully"
                              );
                            });
                        }

                        this.eventService
                          .creatorEnroll(
                            data.result.identifier,
                            this.userId,
                            createRes.result
                          )
                          .subscribe((enrollRes) => {
                            this.eventService
                              .getUserData(this.userId)
                              .subscribe((userRes) => {
                                this.eventService
                                  .costomUserEnroll(
                                    data.result.identifier,
                                    this.userId,
                                    userRes.result.response.firstName,
                                    userRes.result.response.lastName,
                                    this.email
                                  )
                                  .subscribe((res) => {
                                    console.log("costum user enrolled");
                                  });
                              });
                          });
                      } else {
                        console.log("Errror while calling enroll API");
                      }

                      var action = "enroll";
                      if (
                        createBatchRequestValue.enrollmentType == "invite-only"
                      ) {
                        const enrollmentObservables: Observable<any>[] = [];

                        this.selectedUserIds.forEach((userId) => {
                          let firstName = "";
                          let lastName = "";
                          let email = "";
                          const customUserEnroll$ =
                            this.eventService.costomUserEnroll(
                              data.result.identifier,
                              userId,
                              firstName,
                              lastName,
                              email
                            );

                          const enrollToEventPost$ =
                            this.eventService.enrollToEventPost(
                              action,
                              data.result.identifier,
                              userId,
                              createRes.result
                            );

                          enrollmentObservables.push(
                            customUserEnroll$,
                            enrollToEventPost$
                          );
                        });

                        forkJoin(enrollmentObservables)
                          .pipe(
                            finalize(() => {
                              this.eventService
                                .sendEmailNotification(
                                  this.selectedUserIds,
                                  this.eventLink,
                                  this.formValues.name,
                                  this.formValues.startDate,
                                  this.formValues.startTime,
                                  this.formValues.endTime
                                )
                                .subscribe(
                                  (emailRes) => {
                                    console.log(
                                      "Email notifications sent successfully",
                                      emailRes
                                    );
                                  },
                                  (emailError) => {
                                    console.error(
                                      "Error sending email notifications",
                                      emailError
                                    );
                                  }
                                );
                            })
                          )
                          .subscribe(
                            (responses) => {
                              console.log(
                                "All enrollments completed",
                                responses
                              );
                            },
                            (error) => {
                              console.error(
                                "Error in one or more enrollments",
                                error
                              );
                            }
                          );
                      } else {
                      }
                    },
                    (err) => {
                      console.log({ err }, "Error creating batch");
                      // Handle the error
                    }
                  );
              } else {
                return observableOf(res.result.response.content[0]);
              }
            }
          },
          (err) => {
            console.log({ err });
            this.sbToastService.showIziToastMsg(
              err.error.result.messages[0],
              "error"
            );
          }
        );
      });
  }

  cancel() {
    this.closeSaveForm.emit();
  }

  updateEventWithGmeetLink(eventType) {
    if (eventType == "private") {
      this.eventCreateService
        .updateEventwithGmeetLink(
          this.formValues,
          this.eventID,
          this.versionKey
        )
        .subscribe(
          (data) => {
            if (data.responseCode == "OK") {
              this.dataSubmitted(data, "update");
            }
          },
          (err) => {
            console.log({ err });
            // this.sbToastService.showIziToastMsg(err.error.result.messages[0], 'error');
          }
        );
    }
  }
  /**
   * For time validation
   *
   * @param sdate Contains data
   * @param time Contains time
   * @returns Return true if event start time is greater current time
   */
  timeValidation(date, time) {
    var startEventTime = new Date(date + " " + time);
    var startDifference = startEventTime.getTime() - this.today.getTime();
    var timeDiff = Math.round(startDifference / 60000);

    return timeDiff > 0 ? true : false;
  }

  /**
   * For date validation
   *
   * @param sdate Contains start data
   * @param edate Contains end data
   * @returns
   */
  dateValidation(sdate, edate) {
    var startEventDate = new Date(sdate);
    var endEventDate = new Date(edate);

    var startDifference = endEventDate.getTime() - startEventDate.getTime();
    var timeDiff = Math.round(startDifference / 60000);

    return timeDiff >= 0 ? true : false;
  }

  appIconDataHandler(event) {
    this.appIcon = event.url;
  }
}
